// src/components/settings/DistributorFormModal.jsx

import React from "react";
import "../../assets/styles/common.css";
import "./Settings.css"; // Keep this for specific settings tab styles

const DistributorFormModal = ({
  showModal,
  editingDistributor,
  tempDistributor,
  handleChange,
  handleSaveDistributor,
  onClose,
}) => {
  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>
          {editingDistributor ? "Edit Distributor" : "Add New Distributor"}
        </h3>
        <form onSubmit={handleSaveDistributor} className="modal-form">
          <div className="form-group">
            <label>Company Name:</label>
            <input
              type="text"
              name="companyName"
              value={tempDistributor.companyName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Contact Person:</label>
            <input
              type="text"
              name="contactPerson"
              value={tempDistributor.contactPerson}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Contact No.:</label>
            <input
              type="text" // Use text for phone numbers to allow various formats
              name="contactNo"
              value={tempDistributor.contactNo}
              onChange={handleChange}
              required
            />
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn-primary">
              {editingDistributor ? "Update Distributor" : "Add Distributor"}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DistributorFormModal;
